import { api } from './api';

interface User {
  id: string;
  name: string;
  email: string;
  nameOrganization: string;
  profile?: string;
}

export interface LoginResponse {
  sendMFACode: boolean;
  message: string;
  email: string;
  activeMfa?: boolean;
  requireMFA?: boolean; // Campo que o backend realmente retorna
  // Campos para login direto quando MFA está inativo
  access_token?: string;
  userId?: string;
  organizationId?: string[];
  profile?: string;
  nameOrganization?: string;
  organizationName?: string;
  organization_name?: string;
  orgName?: string;
}

export interface MfaResponse {
  access_token: string;
  userId: string;
  organizationId: string[];
  profile: string;
  nameOrganization?: string;
  organizationName?: string;
  organization_name?: string;
  orgName?: string;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post('/api/auth/login', {
      email,
      password
    });
    return response.data;
  },

  async verifyMfa(email: string, code: string): Promise<MfaResponse> {
    const response = await api.post('/api/auth/mfa', {
      email,
      code
    });
    
    // Log detalhado para debug
    console.log("Resposta completa da API MFA:", response.data);
    
    // Tentar diferentes campos para o nome da organização
    const orgName = response.data.nameOrganization || 
                   response.data.organizationName || 
                   response.data.organization_name || 
                   response.data.orgName;
    
    if (orgName) {
      response.data.nameOrganization = orgName;
      console.log("Nome da organização encontrado:", orgName);
    } else if (response.data.organizationId) {
      console.log("API não retornou nome da organização em nenhum campo conhecido, usando valor padrão");
      console.log("Campos disponíveis:", Object.keys(response.data));
      response.data.nameOrganization = "Organização";
    }
    
    return response.data;
  }
}; 